import React from "react";
import { Box, Autocomplete, TextField, IconButton, InputAdornment } from "@mui/material";
import { Search as SearchIcon, Clear as ClearIcon } from "@mui/icons-material";

interface SearchAutocompleteProps {
  placeholder: string;
  options: string[];
  value: string;
  onChange: (newValue: string | null) => void;
  showIcons?: boolean; // ✅ חדש
}

const SearchAutocomplete: React.FC<SearchAutocompleteProps> = ({
  placeholder,
  options,
  value,
  onChange,
  showIcons = true, // ✅ חדש
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#e0e0e0",
        borderRadius: "8px",
        paddingX: "8px",
        paddingY: "4px",
        width: "100%",
        maxWidth: 400,
        
      }}
    >
      <Autocomplete
        freeSolo
       
        options={options}
        value={value}
        onInputChange={(event, newValue) => onChange(newValue)}
        sx={{ flexGrow: 1,
             position: "relative",
         }}
         disablePortal={false} // ✅ מספיק
         slotProps={{
           popper: {
             modifiers: [
               {
                 name: "preventOverflow",
                 options: {
                   boundary: "viewport",
                 },
               },
             ],
             disablePortal: false, // ✅ לשים כאן!
           },
           listbox: {
             sx: {
                maxHeight: 400,
                direction: "rtl", // הצמדה לימין
                textAlign: "right", // יישור טקסט
                paddingRight: 1, // ריווח קל מהצד הימני
              },
           },
         }}
        renderInput={(params) => (
          <TextField
            {...params}
           
            variant="standard"
            placeholder={placeholder}
            fullWidth
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              endAdornment: showIcons !== false ? ( // ✅ שינוי כאן
                <InputAdornment position="end">
                  <SearchIcon sx={{ color: "gray" }} />
                </InputAdornment>
              ) : null,
              startAdornment: showIcons !== false && value ? ( // ✅ שינוי כאן
                <InputAdornment position="start">
                  <IconButton size="small" onClick={() => onChange("")}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
            sx={{
              "& .MuiInputBase-input": {
                padding: "10px",
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default SearchAutocomplete;
